package com.karyadina.service

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

actual object PlatformFileHelper {
    /**
     * Open a file (download it in browser)
     */
    /**
     * Open a file (download it in browser)
     */
    @OptIn(ExperimentalTime::class)
    actual suspend fun openFile(filePath: String, mimeType: String) {
        // In web, "opening" a file means downloading it
        val extension = getExtensionFromMimeType(mimeType)
        val fileName = "karyadina_${Clock.System.now().toEpochMilliseconds()}.$extension"
        triggerDownload(filePath, fileName)
    }
    
    /**
     * Share a file using Web Share API or download
     */
    @OptIn(ExperimentalTime::class)
    actual suspend fun shareFile(filePath: String, mimeType: String) {
        // Try Web Share API first
        try {
            if (js("navigator.share !== undefined") as Boolean) {
                val shareData = js("({url: filePath})")
                js("navigator.share(shareData)").unsafeCast<kotlin.js.Promise<Unit>>()
            } else {
                // Fallback: download the file
                val extension = getExtensionFromMimeType(mimeType)
                val fileName = "shared_karyadina_${Clock.System.now().toEpochMilliseconds()}.$extension"
                triggerDownload(filePath, fileName)
            }
        } catch (e: Exception) {
            console.error("Failed to share file", e)
            // Fallback to download on error
            val extension = getExtensionFromMimeType(mimeType)
            val fileName = "shared_karyadina_${Clock.System.now().toEpochMilliseconds()}.$extension"
            triggerDownload(filePath, fileName)
        }
    }
    
    private fun getExtensionFromMimeType(mimeType: String): String {
        return when (mimeType.lowercase()) {
            "application/pdf" -> "pdf"
            "image/jpeg", "image/jpg" -> "jpg"
            "image/png" -> "png"
            "text/plain" -> "txt"
            else -> "bin"
        }
    }
    
    private fun triggerDownload(uri: String, fileName: String) {
        try {
            val link = document.createElement("a") as HTMLAnchorElement
            link.href = uri
            link.download = fileName
            document.body?.appendChild(link)
            link.click()
            document.body?.removeChild(link)
        } catch (e: Exception) {
            console.error("Failed to trigger download", e)
        }
    }

    /**
     * Copy an image from a URI to app's private storage
     * In Web, we don't have "private storage" files, so we just return the URI as is (it's likely a blob)
     */
    actual suspend fun saveImageToAppStorage(uri: String): String? {
        return uri
    }
}
